import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, EventEmitter, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpService } from '../../../../services/http.service';
import { isNullOrUndefined } from '../../../../modules/shared';

@Component({
  selector: 'app-role-valid-scope',
  templateUrl: './role-valid-scope.component.html',
  styleUrls: ['./role-valid-scope.component.scss']
})
export class RoleValidScopeComponent implements OnInit, OnChanges {
  @Input('initScope') selectedScope: any[] = [];
  @Input('scopeEndPoint') scopeEndPoint: string = '';
  @Input('application') application: string = '';
  @Input('disabled') disabled: boolean = false;
  @Output('onScopeUpdate') onScopeUpdate = new EventEmitter<any>();
  @Output('isValidScope') isValidScope = new EventEmitter<boolean>();

  scopeTypes: any[] = [];
  scopeNames: {[key: string]: {[key: string]: any[]}} = {};

  max: any;
  // userMgmtApplicationId: string = '6d421cf8-5ed8-459b-a9b3-6236c57b7094';

  scopeForm = new FormGroup({
    validScopes: new FormArray([])
  })

  constructor(
    private httpSrv: HttpService
  ) { }

  ngOnInit() {
    if(this.disabled) {
      this.scopeForm.disable();
    }
    
    this.validScopesArray.valueChanges.subscribe((data:any) => {
      this.emitScopeStatus();
      const areValid = data.reduce((a: any, e: any) => !a ? a : e.scopeType && e.scopeName,true);
      if(areValid) {
        // Flatten the scope records.
        let flattenedRecords: any[] = [];

        data.forEach((scope: any) => {
          if(typeof scope.scopeName === 'string') {
            flattenedRecords.push(this.buildScopeObj(scope.scopeType, scope.scopeName));
            return;
          }

          scope.scopeName.forEach((sn: any) => {
            flattenedRecords.push(this.buildScopeObj(scope.scopeType, sn));
          })
        })
        this.onScopeUpdate.emit(flattenedRecords);
      }
    })
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    // If application changes
    this.validScopesArray.clear();
    // this.getScopeTypesInApplication();
    // change for mesa, need to move this to backend
    this.scopeTypes = ["NON_HIERARCHY"];
    this.updateMax();
    const types: any = {};
    this.selectedScope.forEach(s => types[s.scopeType] = true);
    
    // change for mesa, need to move this to backend
    // this.scopeTypes.forEach(type => this.getScopeNamesUnderTypes(type));
    const scopeNames = ['application'];
    this.scopeNames = this.scopeNames || {};
    this.scopeNames[this.application] = this.scopeNames[this.application] || {};
    this.scopeNames[this.application]['NON_HIERARCHY'] = scopeNames;

    // If scope updated
    if(changes['selectedScope']) {
      this.validScopesArray.clear();

      // Group by scopeType
      const currentScope = changes['selectedScope'].currentValue || [];
      const scopeNamesGroupByType: any = {};

      currentScope.forEach((s: any) => {
        // Fetch the existing scope names in that type
        // if not there insert new key with scope type
        scopeNamesGroupByType[s.scopeType] = scopeNamesGroupByType[s.scopeType] || [];

        // Push the current scope name into the array.
        scopeNamesGroupByType[s.scopeType].push(s.scopeName);
      });

      Object.keys(scopeNamesGroupByType).forEach(st => {
        let scopeObj = {
          scopeType: st,
          scopeName: scopeNamesGroupByType[st]
        }
        this.addNewScope(scopeObj);
      })
    }
  }

  emitScopeStatus(){
    this.isValidScope.emit(!this.validScopesArray.valid)
  }

  updateMax() {
    this.max = this.scopeTypes.length;
  }

  getScopeTypesInApplication() {
    this.scopeTypes = [];
    this.updateMax();

    if(!this.scopeEndPoint) {
      console.error("Scope end point is missing for application: " + this.application);
      return;
    }

    this.httpSrv.makeGetApiCall("GET_SCOPE_TYPES", this.scopeEndPoint).subscribe({
      next: (res: any) => {
        this.scopeTypes = res;
        this.updateMax();
        const types: any = {};
        this.selectedScope.forEach(s => types[s.scopeType] = true);

        // Load options for all the types that are already selected.
        this.scopeTypes.forEach(type => this.getScopeNamesUnderTypes(type));
      },
      complete: () => {},
      error: (err: any) => {
        console.log("err:: ", err);
      }
    });
  }

  getScopeNamesUnderTypes(type: string) {
    if(!this.scopeNames[this.application]) {
      this.httpSrv.makeGetApiCall('GET_SCOPE_NAMES_UNDER_TYPE', this.scopeEndPoint, {replaceParams: {REPLACE_SCOPE_TYPE: type}}).subscribe({
        next: (res: any) => {
          const scopeNames = res.response || [];
          this.scopeNames = this.scopeNames || {};
          this.scopeNames[this.application] = this.scopeNames[this.application] || {};
          this.scopeNames[this.application][type] = scopeNames;
        },
        complete: () => {},
        error: (err: any) => {
          console.log("err:: ", err);
        }
      });
    }
  }

  getScopeTypeFromValidScopesArray(index: number) {
    if(isNullOrUndefined(index)) return null;

    if(!this.validScopesArray.controls || !this.validScopesArray.controls[index]) return null;

    return this.validScopesArray.controls[index].get('scopeType')?.value;
  }

  getScopeNamesForType(index: number) {
    const type = this.getScopeTypeFromValidScopesArray(index);
    if(!type || !this.scopeNames[this.application]) return [];
    return this.scopeNames[this.application][type] || [];
  }

  get validScopesArray(): any {
    return this.scopeForm.get('validScopes') as FormArray
  }

  get selectedScopeTypes(): string[] {
    const currentScope = this.validScopesArray.value;
    return currentScope.map((s: any) => s.scopeType);
  }

  getScopeType(index: number) {
    const scopeInfo = this.validScopesArray.value[index];
    return scopeInfo ? scopeInfo.scopeType : null;
  }

  buildScopeId(st: string, sn: string) {
    return st + "##" + sn;
  }

  buildScopeObj(st: string, sn: string) {
    return {
      scopeType: st,
      scopeName: sn
    }
  }

  checkValidScope(){
    let roles = this.validScopesArray.getRawValue();
    // console.log()
    // this.isValidAvailable.emit()
  }

  newScope(value: any): FormGroup {
    value = value || {};
    return new FormGroup({
      scopeType: new FormControl(value.scopeType || '', [Validators.required]),
      scopeName: new FormControl(value.scopeName || '', [Validators.required])
    });
  }

  addNewScope(value: any = {scopeType: '', scopeName: ''}) {
    let isValidScopes = this.validScopesArray.controls.reduce((a:any, e:any) => !a ? a : e.valid, true);
    if(!isValidScopes || (this.max && this.validScopesArray.length >= this.max)) {
      console.log("Existing form is empty or limit exceeded");
      return;
    }
    this.validScopesArray.push(this.newScope(value));
  }

  removeScope(index: number) {
    this.validScopesArray.removeAt(index);
  }
}
